export const features = [
  {
    icon: "fas fa-users",
    title: "Expert Team",
    description:
      "Skilled professionals with extensive experience across various technology domains and industries.",
  },
  {
    icon: "fas fa-cogs",
    title: "Tailored Solutions",
    description:
      "Custom approaches designed to address your specific business challenges and requirements.",
  },
  {
    icon: "fas fa-chart-line",
    title: "Results-Driven",
    description:
      "Focus on delivering measurable business outcomes and ROI for our clients.",
  },
  {
    icon: "fas fa-shield-alt",
    title: "Security-First",
    description:
      "Robust security practices integrated into every solution we deliver.",
  },
  {
    icon: "fas fa-rocket",
    title: "Agile Approach",
    description:
      "Flexible and responsive development methods that adapt to changing needs.",
  },
  {
    icon: "fas fa-headset",
    title: "Ongoing Support",
    description:
      "Comprehensive maintenance and support to ensure long-term success.",
  },
];

export const testimonials = [
  {
    quote:
      "Anchor Sprint transformed our legacy systems into a modern, scalable platform that has significantly improved our operational efficiency.",
    name: "John Doe",
    title: "CTO, Global Enterprises",
    initials: "JD",
  },
  {
    quote:
      "The digital transformation strategy developed by Anchor Sprint helped us stay ahead of our competition and better serve our customers.",
    name: "Jane Smith",
    title: "CEO, Innovative Solutions",
    initials: "JS",
  },
  {
    quote:
      "The cloud migration project was completed ahead of schedule and below budget. Our systems now run faster and more securely than ever before.",
    name: "Robert Johnson",
    title: "IT Director, Tech Industries",
    initials: "RJ",
  },
];
